module.exports = __webpack_public_path__ + "img/icon_pdf.16491623.svg";